<template>
<b-form-group align="left">
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label>Fecha Inicio : </label>
    <b-form-datepicker v-model="fechaInicio"
    placeholder="Elije una fecha" today-button reset-button close-button label-today-button="Hoy" 
    label-reset-button="Limpiar" label-close-button="Cerrar"></b-form-datepicker>
</b-form-group>
</template>

<script>
export default {
    name: "FechaInicio",
    props: { 
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        fechaInicio: null,

    }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {        
    },
    mounted() { 
    }, 
}
</script>
